module.exports = __webpack_public_path__ + "img/CulturaRF.4fa8f818.png";